import { RequestWithName, isFailure } from "@sportal/api";

import {
  FETCH_REQUESTS_NAME,
  FETCH_REQUESTS_NAME_SUCCESS,
  FETCH_REQUESTS_NAME_FAILURE,
  RequestsWithNameActionTypes,
} from "./requestsWithName.types";
import { SBThunkAction } from "../../redux.types";
import { getSubscriberId } from "../../info/info.selectors";
import {
  Notificator,
  NotificationActionTypes,
} from "../../../components/notification";

export const fetchRequestsWithName =
  (
    initialLoad = false
  ): SBThunkAction<
    void,
    RequestsWithNameActionTypes | NotificationActionTypes
  > =>
  async (dispatch, getState, { api }) => {
    if (initialLoad) {
      dispatch({ type: FETCH_REQUESTS_NAME });
    }

    const subscriberId = getSubscriberId(getState());
    const result = await api.ssm.deviceRequests.getDevicesWithName(
      subscriberId
    );

    if (isFailure(result)) {
      dispatch(Notificator.error("failed_to_load_requests"));
      dispatch(fetchRequestsWithNameFailure(result.error));
      return;
    }

    dispatch(fetchRequestsWithNameSuccess(result.data));
  };

export const fetchRequestsWithNameSuccess = (
  requestsWithName: RequestWithName[]
): RequestsWithNameActionTypes => ({
  type: FETCH_REQUESTS_NAME_SUCCESS,
  payload: requestsWithName,
});

const fetchRequestsWithNameFailure = (
  error: object & { code: string | number }
): RequestsWithNameActionTypes => ({
  type: FETCH_REQUESTS_NAME_FAILURE,
  payload: error,
});
